import { combineReducers } from "@reduxjs/toolkit";

import {
	globalStatePriceZoneDataState,
	globalStatePriceZoneDataReducer,
	globalStatePriceZoneDataAction,
} from "./data";

export type StatePriceZone = {
	data: globalStatePriceZoneDataState;
};

export const priceZones = combineReducers<StatePriceZone>({
	data: globalStatePriceZoneDataReducer,
});

export const globalStatePriceZoneAction = {
	data: globalStatePriceZoneDataAction,
};

export default priceZones;
